import React from "react";
import MetaForm from "./MetaForm";

function App() {
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-center text-gray-900 mb-8">
          Free Keyword Grouping Tool
        </h1>
        <p className="text-center text-gray-600 mb-8 max-w-3xl mx-auto">
          Organize your keywords into semantically related groups with advanced
          features like keyword difficulty estimation, search volume analysis,
          and relationship visualization.
        </p>
        <MetaForm />
        <div className="mt-12 text-center text-gray-600">
          <h2 className="text-2xl font-semibold mb-4">Advanced Features</h2>
          <ul className="list-disc list-inside text-left max-w-3xl mx-auto">
            <li className="mb-2">
              Keyword difficulty and search volume estimation
            </li>
            <li className="mb-2">
              Interactive keyword relationship visualization
            </li>
            <li className="mb-2">Edit and refine generated keyword groups</li>
            <li className="mb-2">
              Suggest related keywords for deeper analysis
            </li>
            <li>Detailed CSV export with additional keyword metrics</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default App;
